import Vue from 'vue'
import Vue2Jed, { Messages } from './vue2jed'
import config from '@/config'
import { Lang, LangMap } from 'proto/eshop/Basket_pb'
import { reduce as _reduce } from 'lodash'

type InvLangMap<K extends keyof LangMap = keyof LangMap> = {
	[key in LangMap[K]]: K
}

const langMap = _reduce(Lang, (res, value, key) => {
	return { ...res, [value]: key }
}, <InvLangMap>{})

// import all available translations
const PO_EXPR = /\.?(\w+)\.po$/
const importLocales = require.context('locales', true, /\.?(\w+)\.po$/)

const messages = importLocales.keys()
	.reduce((res: Messages, path: string) => {
		const [ , key ] = PO_EXPR.exec(path) as RegExpMatchArray
		res[key] = importLocales(path)
		return res
	}, {} as Messages)

export const i18n = new Vue2Jed({
	messages,
	locale: () => {
		const language = langMap[config.lang]
		const lang = language.toLowerCase()
		if (lang in messages) {
			return lang
		}
		const [ locale ] = navigator.language.split('-')
		if (locale in messages) return locale
		return 'en'
	},
})

Vue.use(Vue2Jed, {
	instance: i18n,
})

export default i18n
